export default __webpack_public_path__ + "static/media/icon_facility_elevator.333657e0.svg";